"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function useFormContext(reducer, initialForm, props) {
    var _a = React.useReducer(reducer, initialForm), state = _a[0], dispatch = _a[1];
    var update = function (field, value) { return dispatch({ field: field, value: value, type: 'Update' }); };
    var remove = function (field) { return dispatch({ field: field, type: 'Remove' }); };
    var addValidation = function (field, validations) { return dispatch({ field: field, validations: validations, type: 'AddValidations' }); };
    var removeValidations = function (field, validations) { return dispatch({ field: field, validations: validations, type: 'RemoveValidations' }); };
    var showValidationStatus = function (field, status) { return dispatch({ field: field, status: status, type: 'ShowValidationStatus' }); };
    var submit = function (submit) { return dispatch({ submit: submit, onError: props.onError, type: 'Submit' }); };
    var validate = function (field) { return dispatch({ field: field, type: 'Validate' }); };
    var getState = function () { return state; };
    return { update: update, remove: remove, addValidation: addValidation, removeValidations: removeValidations, showValidationStatus: showValidationStatus, submit: submit, validate: validate, getState: getState, hasProvider: true };
}
exports.useFormContext = useFormContext;
